import { render, staticRenderFns } from "./OrganizationPeerGroupClassroomImporter.vue?vue&type=template&id=5f9badcc&"
import script from "./OrganizationPeerGroupClassroomImporter.vue?vue&type=script&lang=ts&"
export * from "./OrganizationPeerGroupClassroomImporter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports